<template>
  <svg
    :width="width ? width : height ? height : 19"
    :height="height ? height : width ? width : 18"
    viewBox="0 0 19 18"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <path
      d="M11.98 6.52a5.34 5.34 0 0 1 .02 7.54l-.02.01-2.36 2.37a5.35 5.35 0 0 1-7.56-7.56l1.3-1.3a.56.56 0 0 1 .97.37c.02.62.13 1.25.34 1.85.07.2.02.43-.14.59l-.46.46a2.55 2.55 0 0 0-.04 3.58c.99 1 2.6 1.01 3.6.02L10 12.09a2.53 2.53 0 0 0-.36-3.88.56.56 0 0 1-.24-.45 1.4 1.4 0 0 1 .4-1.05l.75-.74c.2-.19.5-.21.72-.06.26.18.5.39.72.6zm4.96-4.96a5.35 5.35 0 0 0-7.56 0L7.02 3.93H7a5.34 5.34 0 0 0 .74 8.16c.22.15.53.13.72-.06l.74-.74c.3-.3.43-.68.41-1.05 0-.18-.1-.34-.24-.45a2.53 2.53 0 0 1-.36-3.88l2.36-2.36c1-1 2.61-.99 3.6.02.97 1 .94 2.6-.04 3.58l-.46.46a.57.57 0 0 0-.14.59c.2.6.32 1.23.34 1.85.02.49.62.72.96.37l1.3-1.3a5.35 5.35 0 0 0 0-7.56z"
      :fill="iconColor"
      fill-rule="nonzero"
    />
  </svg>
</template>

<script>
export default {
  name: 'link-icon',
  props: {
    iconColor: {
      type: String,
      default: '#9900EA',
    },
    height: {
      type: Number,
      required: false,
    },
    width: {
      type: Number,
      required: false,
    },
  },
};
</script>
